export const createAudioFileString = s3Key => {
  const index = s3Key.lastIndexOf('/') + 1;
  const fname = s3Key.substr(index);
  return fname;
};
